export const IconSplit = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={
          "M10.708 0.312012L11.4053 1.00927L7.13965 5.2749L4.51465 2.6499L1.29492 " +
          "5.86963L0.597656 5.17236L4.51465 1.25537L7.13965 3.88037L10.708 0.312012Z"
        }
        fill="currentColor"
      />
      <path
        d={
          "M10.708 3.13037L11.4053 3.82764L7.13965 8.09325L4.51465 5.46826L1.29492 " +
          "8.688L0.597656 7.99072L4.51465 4.07373L7.13965 6.69873L10.708 3.13037Z"
        }
        fill="currentColor"
      />
      <path
        d={
          "M10.708 6.13037L11.4053 6.82764L7.13965 11.0932L4.51465 8.46825L1.29492 " +
          "11.688L0.597656 10.9907L4.51465 7.07373L7.13965 9.6987L10.708 6.13037Z"
        }
        fill="currentColor"
      />
    </svg>
  );
};
